import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlSegments } from '../jurisdiction.constants';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../services/environment.service';
import { LocationDetails } from '../jurisdiction.domain';

@Injectable()
export class LocationService {
  private readonly baseUrl: string;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.apiUrl;
  }

  get tileDataUrl(): string {
    return `${this.baseUrl}location/tile/{z}/{x}/{y}`;
    // return 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'; //OSM
  }

  getLocationDetails(latitude: number, longitude: number, language: string): Observable<LocationDetails> {
    const url = `${this.baseUrl}${UrlSegments.GetLocationDetails}?latitude=${latitude}&longitude=${longitude}&language=${language}`;

    return this.httpClient.get<LocationDetails>(url);
  }

  searchLocations(searchTerm: string): Observable<LocationDetails[]> {
    const url = `${this.baseUrl}${UrlSegments.SearchLocations}?searchTerm=${encodeURIComponent(searchTerm)}`;

    return this.httpClient.get<LocationDetails[]>(url);
  }
}
